import React, { Component }     from 'react';
import { connect }              from 'react-redux';
import { GetRegistroPostEquipe }      from '../../../../actions/grupoAction';
import EquipeTimeLine           from './equipe_timeLine';
import TopoComunicacao           from '../topo_comunicacao';
import { GetActionBg }          from '../../../../actions/scopoAction';
import bg_equipe                from "../../../../img/bg/bg_equipe.png";
import { SetError }             from '../../../../actions/notificacaoAction';

class Equipe extends Component {

    constructor(props) {

        super(props);
        this.state = {
            returnItemPublic : [],
            logPost          : false,
            logAluno         : false,
            logForm          : false,
            logItem          : false,
            redirect         : false,
            id               : (this.props.match ? this.props.match.params.id: "")
        }

    }

    componentWillMount() {
        this.props.GetActionBg(bg_equipe);
       this.CarregarPosts();
    }

    CarregarPosts(){
        this.setState({ logPost : false});
        this.props.GetRegistroPostEquipe(this.props.session.id,this.state.id)        
        .then((response) => {
            this.setState({ logPost : true,logForm:true,logAluno:true,equ_id : (response.payload.data.equipe?response.payload.data.equipe.equ_id:0)  });  
             if(!response.payload.data || response.payload.data.equipe=== null){
                alert("O seu usuário, não foi encontrado em nenhum Equipe. Entre em contato com o seu professor, para maiores informações.");
                this.setState({ redirect : true }); 
             }
        }).catch((error) => {
           this.props.SetError(500);
        }); 
    
    }

    render() {
        return (
          <div className="hud-middle-center active">
             <TopoComunicacao nome="Equipe"/>
             <main className="hud-middle-center-content">
                 <EquipeTimeLine equ_id={this.state.id}/>                                   
              </main>
            </div>     
        );
    }
}

function mapStateToProps(state){

    return {  
             session     : state.auth.session,
             menu        : state.configReducer.menu,
             nome_equipe : state.equipeReducer.nome_equipe
           }
}

export default connect(mapStateToProps,{GetRegistroPostEquipe,GetActionBg,SetError})(Equipe);



// WEBPACK FOOTER //
// ./src/components/aluno/comunicacao/equipe/equipe.js